import { createRoot } from 'react-dom/client';

import { DesignatedFundLanding } from './DesignatedFundLanding';

$(function () {
    const dataElement = document.getElementById('js-init-data');
    const data = JSON.parse(dataElement.textContent);
    const root = createRoot(document.getElementById('content'));
    root.render(
        <DesignatedFundLanding
            canonicalUrl={data.canonicalUrl}
            title={data.title}
            subtitle={data.subtitle}
            challengeId={data.challengeId}
            designatedFundId={data.designatedFundId}
            photoUrl={data.photoUrl}
            photoCaption={data.photoCaption}
            description={data.description}
            activityFeedTitle={data.activityFeedTitle}
            activityFeedDescription={data.activityFeedDescription}
            donorCount={data.donorCount}
            altImageText={data.altImageText}
            totalRaised={data.totalRaised}
            currentGoal={data.currentGoal}
            activityFeed={data.activityFeed}
            testimonial={data.testimonials[0]}
            acceptingDonations={data.acceptingDonations}
        />,
    );
});
